import * as React from "react";
import {
  Box,
  Radio,
  RadioGroup,
  Stack,
  TextAreaField,
} from "@origin-digital/ods-core";
import { Field, FieldProps, FormikProps, useFormikContext } from "formik";
import { FormValues } from "../types";

const PropertyAccess = () => {
  const { values, setFieldValue } = useFormikContext<FormValues>();
  return (
    <Stack space="medium">
      <Field name="propertyAccess" id="property-access">
        {({ field }: { field: FormikProps<FieldProps> }) => (
          <RadioGroup
            {...field}
            onChange={(e) => {
              setFieldValue("propertyAccess", e.target.value);
              setFieldValue("preventingAccess", "");
            }}
            id="property-access"
            name="propertyAccess"
            label="Is there clear and safe access to the property?"
          >
            <Box
              display="flex"
              flexWrap="wrap"
              flexDirection={{
                xs: "column",
                sm: "column",
              }}
            >
              <Radio id="yes" label="Yes" value="yes" />
              <Radio id="no" label="No" value="no" />
            </Box>
          </RadioGroup>
        )}
      </Field>
      {values.propertyAccess === "yes" ? null : (
        <Field id="preventing-access" name="preventingAccess">
          {({ field }: { field: FormikProps<FieldProps> }) => (
            <TextAreaField
              {...field}
              id="preventing-access"
              value={values.preventingAccess}
              variant="outlined"
              label="What is preventing access?"
              helperText="e.g. locked gate, building debris, unrestrained animals, etc."
            />
          )}
        </Field>
      )}
    </Stack>
  );
};

export default PropertyAccess;
